'use client'

import { TrendingUp, Users } from 'lucide-react'

import { Button } from '@/ui/atoms/button/Button'
import { Panel } from '@/ui/atoms/panel/Panel'
import { Typography } from '@/ui/atoms/typography/Typography'

import { useCardWaitlist } from '../hooks/useCardWaitlist'
import { CardReferralShare } from './CardReferralShare'

export function CardWaitlist() {
  const { position, referralCode, referralCount, boostScore, refresh, isLoading, error } = useCardWaitlist()

  return (
    <div className="flex justify-center">
      <Panel.Wrapper className="w-full max-w-xl">
        <Panel.Content className="flex flex-col gap-6 p-8">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/10">
              <Users className="h-5 w-5 text-primary" />
            </div>
            <Typography variant="h3" gradient>
              You&apos;re On The Waitlist
            </Typography>
          </div>

          <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
            <div className="rounded-lg border border-border/60 bg-background/30 p-4">
              <Typography variant="prompt" className="text-muted-foreground">
                Position
              </Typography>
              <Typography variant="h3">#{position ?? '--'}</Typography>
            </div>

            <div className="rounded-lg border border-border/60 bg-background/30 p-4">
              <Typography variant="prompt" className="text-muted-foreground">
                Referrals
              </Typography>
              <Typography variant="h3">{referralCount}</Typography>
            </div>

            <div className="rounded-lg border border-border/60 bg-background/30 p-4">
              <Typography variant="prompt" className="text-muted-foreground">
                Boost Score
              </Typography>
              <div className="flex items-center gap-2">
                <TrendingUp className="h-4 w-4 text-primary" />
                <Typography variant="h3">{boostScore}</Typography>
              </div>
            </div>
          </div>

          <CardReferralShare referralCode={referralCode} />

          {error && (
            <div className="rounded-lg border border-red-500/20 bg-red-500/10 p-3">
              <Typography variant="p" className="text-red-400 text-sm">
                {error.message || 'Could not load waitlist details.'}
              </Typography>
            </div>
          )}

          <Button variant="outline" onClick={() => refresh()} disabled={isLoading}>
            {isLoading ? 'Refreshing...' : 'Refresh Position'}
          </Button>
        </Panel.Content>
      </Panel.Wrapper>
    </div>
  )
}
